import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import styles from "./addblog.module.css";
import { useEffect, useRef, useState } from "react";
import Dropzone from "react-dropzone";
import { useAuth } from "../../../../hooks/AuthProvider";
import axios from "axios";
import API_BASE_URL from "../../../../config/api";

const toolbarOptions = [
  [{ header: [1, 2, 3, false] }],
  ["bold", "italic", "underline", "strike"],
  [{ list: "ordered" }, { list: "bullet" }],
  ["link", "image"],
  ["clean"],
];

function Addblog({ onSuccess, onCancel, editPost }) {
  const [author, setAuthor] = useState(editPost?.author || "");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(editPost?.image || null);
  const [body, setBody] = useState(editPost?.body || "");
  const [uploading, setUploading] = useState(false);
  const titleRef = useRef();
  const { user, token } = useAuth();

  useEffect(() => {
    if (editPost) {
      if (titleRef.current) titleRef.current.value = editPost.title || "";
    } else if (user?.name) {
      setAuthor(user.name);
    }
  }, [user, editPost]);

  const handleImageDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  async function submitForm(e) {
    e.preventDefault();
    if (!body || body === "<p><br></p>") {
      alert("Body cannot be empty");
      return;
    }
    setUploading(true);
    const formdata = new FormData();
    formdata.append("title", titleRef.current.value || "");
    formdata.append("author", author);
    if (image) formdata.append("attachment", image);
    formdata.append("body", body);
    try {
      const url = editPost
        ? `${API_BASE_URL}/api/v1/blog/${editPost.id}`
        : `${API_BASE_URL}/api/v1/blog`;
      const method = editPost ? axios.put : axios.post;
      const response = await method(url, formdata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        titleRef.current.value = "";
        setBody("");
        setImage(null);
        setImagePreview(null);
        if (onSuccess) onSuccess();
      }
    } catch (err) {
      if (err.response?.status === 403) {
        alert("You do not have permission to access this");
      } else {
        alert("Failed to save post");
      }
    }
    setUploading(false);
  }

  return (
    <div className={styles.addBlog}>
      <form className={styles.blogForm} onSubmit={submitForm}>
        <div className={styles.blogTopic}>
          <img
            src="/arrow-left.png"
            alt="back"
            style={{ cursor: "pointer" }}
            onClick={onCancel}
          />
          <h2>{editPost ? "Edit blog post" : "Add a new blog post"}</h2>
        </div>

        <div className={styles.blogTitle}>
          <h4>Blog Title</h4>
          <input
            type="text"
            name="title"
            placeholder="Enter Title..."
            ref={titleRef}
            defaultValue={editPost?.title || ""}
            required
          />
        </div>

        <h4>Blog Image</h4>
        <Dropzone onDrop={handleImageDrop} accept={{ "image/*": [".png", ".jpg", ".jpeg"] }} maxFiles={1}>
          {({ getRootProps, getInputProps }) => (
            <div {...getRootProps()} className={styles.dragArea}>
              <input {...getInputProps()} />
              {imagePreview ? (
                <img src={imagePreview} alt="preview" style={{ maxHeight: "180px", maxWidth: "100%" }} />
              ) : (
                <div className={styles.customFileInput}>
                  <span role="button">Browse</span>
                  <p>or drag and drop image</p>
                </div>
              )}
            </div>
          )}
        </Dropzone>

        <div className={styles.quill}>
          <ReactQuill
            theme="snow"
            value={body}
            onChange={setBody}
            modules={{ toolbar: toolbarOptions }}
          />
        </div>

        <div className={styles.blogBtns}>
          <button className={styles.blogScheduleBtn} type="button" onClick={onCancel}>
            Cancel
          </button>
          <button className={styles.blogSubmitBtn} type="submit" disabled={uploading}>
            {uploading ? "Saving..." : editPost ? "Update" : "Publish Now"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default Addblog;
